import { Nilable } from "@shared/utils";

export interface IItemEstadoDTO {
    id: number;
    text: string;
    checkpoint: boolean;
    item_count: number;
}

export class ItemEstadoDTO {
    public id = 0;
    public texto = "";
    public checkpoint = false;
    public cantidad = 0;

    constructor(json: Nilable<Partial<IItemEstadoDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IItemEstadoDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.text != null) {
            this.texto = json.text;
        }
        if (json.checkpoint != null) {
            this.checkpoint = json.checkpoint;
        }
        if (json.item_count != null) {
            this.cantidad = json.item_count;
        }
    }

    public toJSON(): IItemEstadoDTO {
        return {
            id: this.id,
            text: this.texto,
            checkpoint: this.checkpoint,
            item_count: this.cantidad
        };
    }
}
